import { render, staticRenderFns } from "./columnDaily.vue?vue&type=template&id=392458e4&scoped=true&"
import script from "./columnDaily.vue?vue&type=script&lang=js&"
export * from "./columnDaily.vue?vue&type=script&lang=js&"
import style0 from "./columnDaily.vue?vue&type=style&index=0&id=392458e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392458e4",
  null
  
)

export default component.exports